var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.skolskaUloha
      ? _c(
          "main",
          { staticClass: "kvizove-ulohy" },
          [
            _c(
              "article",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === "uvod",
                    expression: "step === 'uvod'"
                  }
                ],
                staticClass: "d-grid position-relative uvod-height"
              },
              [
                _c("img", {
                  staticClass: "uvodny-obr",
                  attrs: { src: "assets/img/uvod-kviz.jpg", alt: "" }
                }),
                _vm._v(" "),
                _vm.skolskaUloha
                  ? _c("div", { staticClass: "position-absolute" }, [
                      _c(
                        "span",
                        { staticClass: "badge-pill --success mb-30" },
                        [_vm._v(_vm._s(_vm.skolskaUloha.nazov))]
                      ),
                      _vm._v(" "),
                      _c("h2", { staticClass: "mb-30" }, [
                        _vm._v(_vm._s(_vm.skolskaUloha.podnadpis))
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "mb-50" }, [
                        _vm._v(_vm._s(_vm.skolskaUloha.zadanie))
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn --primary btn-lg",
                          on: { click: _vm.startQuiz }
                        },
                        [
                          _vm._v("spustiť kvíz"),
                          _c("span", { staticClass: "icon --arrow-right" })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.errorMessage
                        ? _c("p", { staticClass: "text-danger mt-1" }, [
                            _vm._v(_vm._s(_vm.errorMessage))
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "article",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === "kviz",
                    expression: "step === 'kviz'"
                  }
                ],
                staticClass: "d-grid position-relative bg-white without-img"
              },
              [
                _c("div", { staticClass: "count" }, [
                  _c("span", { staticClass: "actual" }, [
                    _vm._v(_vm._s(_vm.currentQuestion))
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "separator" }, [_vm._v("/")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "total" }, [
                    _vm._v(_vm._s(_vm.skolskaUloha.pocet_otazok))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "time" }, [
                  _c("span", { staticClass: "icon icon--stopwatch" }),
                  _c("span", [_vm._v(_vm._s(_vm.timer))])
                ]),
                _vm._v(" "),
                _vm._l(_vm.skolskaUloha.otazky, function(otazka, index) {
                  return [
                    index + 1 === _vm.currentQuestion
                      ? _c("skoly-ulohy-kvizova-otazka", {
                          key: index,
                          attrs: { otazka: otazka },
                          on: { next: _vm.next }
                        })
                      : _vm._e()
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "article",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === "vyhodnotenie",
                    expression: "step === 'vyhodnotenie'"
                  }
                ],
                staticClass: "d-grid position-relative bg-white full-h"
              },
              [
                _c("img", {
                  staticClass: "img-fluid",
                  attrs: { src: "assets/img/vyhodnotenie-bg.jpg", alt: "" }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "position-absolute" },
                  [
                    !_vm.errorMessage
                      ? [
                          _c("img", {
                            staticClass: "img-fluid mb-20",
                            attrs: {
                              src: "assets/img/success-badge.svg",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("h2", { staticClass: "mb-10" }, [
                            _vm._v("Výborne, zvládli ste to!")
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-30" }, [
                            _vm._v("Kravička je na vás pyšná.")
                          ])
                        ]
                      : [
                          _c("img", {
                            staticClass: "img-fluid mb-20",
                            attrs: {
                              src: "assets/img/error-badge.svg",
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("h2", { staticClass: "mb-10" }, [
                            _vm._v(_vm._s(_vm.errorMessage))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "mb-30" }, [
                            _vm._v("Do súťaže nezískavate ani jeden bod")
                          ])
                        ],
                    _vm._v(" "),
                    _c("aside", { staticClass: "d-flex kviz-vysledok" }, [
                      _c("div", { staticClass: "time" }, [
                        _c("span", { staticClass: "icon icon--stopwatch" }),
                        _c("span", [_vm._v(_vm._s(_vm.kvizDuration))])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "status" }, [
                        _c("span", { staticClass: "icon icon--question-mark" }),
                        _vm._v(" "),
                        _c("div", { staticClass: "count" }, [
                          _c("span", { staticClass: "actual" }, [
                            _vm._v(_vm._s(_vm.spravneOdpovede))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "separator" }, [
                            _vm._v("/")
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "total" }, [
                            _vm._v(_vm._s(_vm.skolskaUloha.pocet_otazok))
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "ulohy" },
                          _vm._l(_vm.spravnostOdpovedi, function(value, index) {
                            return _c(
                              "li",
                              {
                                key: index,
                                class: { done: value, wrong: !value }
                              },
                              [_vm._v(_vm._s(index + 1))]
                            )
                          }),
                          0
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.profil.pouzivatel_id
                      ? _c(
                          "router-link",
                          {
                            staticClass: "btn --primary",
                            attrs: {
                              to: {
                                name: "skoly-ulohy",
                                params: {
                                  rocnik:
                                    _vm.profil.pouzivatel_id.pouzivatel_rocnik
                                }
                              }
                            }
                          },
                          [
                            _vm._v("spať na zoznam úloh"),
                            _c("span", { staticClass: "icon --bars" })
                          ]
                        )
                      : _vm._e()
                  ],
                  2
                )
              ]
            ),
            _vm._v(" "),
            _vm.profil.pouzivatel_id && _vm.step !== "kviz"
              ? _c(
                  "router-link",
                  {
                    staticClass: "btn --secondary --circle close-btn",
                    attrs: {
                      to: {
                        name: "skoly-ulohy",
                        params: {
                          rocnik: _vm.profil.pouzivatel_id.pouzivatel_rocnik
                        }
                      }
                    }
                  },
                  [_c("span", { staticClass: "icon --close" })]
                )
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }